import { render, staticRenderFns } from "./MedicineDetail.vue?vue&type=template&id=13eeb456"
import script from "./MedicineDetail.vue?vue&type=script&lang=js"
export * from "./MedicineDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicineDetail.vue?vue&type=style&index=0&id=13eeb456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports